var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alarmclockblacksymbol_79776 1",
    clipPath: "url(#clip0_144_886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3071 2.08096C14.4694 -0.272862 11.0644 -0.686347 8.72402 1.14323L4.45414 4.47798C2.10308 6.31292 1.69763 9.718 3.52989 12.0637L5.19186 14.1906L17.969 4.20774L17.1367 3.14569L16.3071 2.08096Z",
    fill: "#4079FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.67859 28.9756C3.67859 37.1397 7.69983 44.3633 13.8722 48.7765L8.50788 54.1164L10.3996 56L16.1855 50.2384C19.6825 52.1869 23.7118 53.2976 28.0006 53.2976C32.2028 53.2976 36.1538 52.2328 39.6021 50.3574L45.2691 56L47.1609 54.1164L41.9343 48.9115C48.2148 44.5146 52.3225 37.2235 52.3225 28.9756C52.3225 15.5417 41.4343 4.65356 28.0006 4.65356C14.5694 4.65356 3.67859 15.5445 3.67859 28.9756ZM30.7029 28.9541V31.6673H30.6895V31.6781H28.0006V31.6673H17.1908V28.9541H28.0006V12.7609H30.6895V28.954H30.7029V28.9541Z",
    fill: "#4079FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.6414 13.1258L52.4711 12.061C54.3087 9.70722 53.8871 6.30482 51.5468 4.47533L47.2796 1.14058C44.9285 -0.694361 41.5261 -0.267397 39.6966 2.07831L38.0345 4.20508L50.8117 14.1906L51.6414 13.1258Z",
    fill: "#4079FC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockicon);
export default __webpack_public_path__ + "static/media/clockicon.d6109dfa7bfa50a78f84f97d2e83f1b1.svg";
export { ForwardRef as ReactComponent };